import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="dropdown language-switcher">
      <button
        className="btn btn-outline-light btn-sm dropdown-toggle d-flex align-items-center px-2 py-1"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ fontWeight: 500, fontSize: '1rem', borderRadius: '0.5rem', minWidth: '90px' }}
      >
        <span style={{ fontSize: '1.2rem', marginRight: '6px' }}>{language === 'en' ? '🇺🇸' : '🇻🇳'}</span>
        <span>{language === 'en' ? 'EN' : 'VI'}</span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
        <li>
          <button
            className={`dropdown-item d-flex align-items-center ${language === 'en' ? 'active' : ''}`}
            onClick={() => setLanguage('en')}
            style={{ fontWeight: language === 'en' ? 600 : 400 }}
          >
            <span style={{ fontSize: '1.2rem', marginRight: '8px' }}>🇺🇸</span>
            <span>English</span>
          </button>
        </li>
        <li>
          <button
            className={`dropdown-item d-flex align-items-center ${language === 'vi' ? 'active' : ''}`}
            onClick={() => setLanguage('vi')}
            style={{ fontWeight: language === 'vi' ? 600 : 400 }}
          >
            <span style={{ fontSize: '1.2rem', marginRight: '8px' }}>🇻🇳</span>
            <span>Tiếng Việt</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;